import { render, staticRenderFns } from "./AbsenceType.vue?vue&type=template&id=525318cb"
import script from "./AbsenceType.vue?vue&type=script&lang=js"
export * from "./AbsenceType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports